import { Box, Typography } from '@mui/material';

import { OPACITY } from '../../../theme';
import { levelsPercent, named } from '../growth';
import { GROWTH } from '../tokens';
import type { SchemeLevel } from '../types';
import { bandNames, colorOf } from './cardParts';

export function LevelBar({ levels, scheme, faded }: { levels: number[]; scheme: SchemeLevel[]; faded?: boolean }) {
  const percents = levelsPercent(levels);
  const names = bandNames(scheme);
  const description = percents.map((p, i) => `${p}% ${names[i] ?? ''}`.trim()).join(', ');
  return (
    <Box
      role="img"
      aria-label={description}
      data-testid="level-bar"
      sx={{ display: 'flex', height: 12, borderRadius: '4px', overflow: 'hidden', mt: '4px', bgcolor: levels.some((v) => v > 0) ? 'transparent' : GROWTH.track }}
      style={{ opacity: faded ? OPACITY.provisional : 1 }}
    >
      {levels.map((value, i) =>
        value > 0 ? <Box key={names[i] ?? i} data-testid="level-segment" sx={{ flexBasis: 0, bgcolor: colorOf(scheme, i + 1) }} style={{ flexGrow: value }} /> : null,
      )}
    </Box>
  );
}

export function LevelLabel({ avg, boyAvg, scheme, stacked }: { avg: number | null; boyAvg: number | null; scheme: SchemeLevel[]; stacked?: boolean }) {
  return (
    <Typography component="span" data-testid="level-label" sx={{ display: 'block', fontFamily: GROWTH.font, fontSize: '12px', lineHeight: '16px', fontWeight: 700, color: GROWTH.ink, whiteSpace: 'nowrap' }}>
      {`Avg ${named(avg, scheme)}`}
      {stacked ? <br /> : ' '}
      <Box component="span" sx={{ fontWeight: 500, color: GROWTH.muted }}>
        {`${stacked ? '' : '· '}BOY ${named(boyAvg, scheme)}`}
      </Box>
    </Typography>
  );
}
